<script>
import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'doughnutChart',
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    let charOptions = this.options
    if (charOptions && Object.keys(charOptions).length > 0) {
      let self = this
      charOptions.animation = {
        onComplete: function () {
          self.$emit('afterComplete')
        }
      }
    }
    // Overwriting base render method with actual data.
    this.renderChart(this.chartData, charOptions)
  }
}
</script>



// WEBPACK FOOTER //
// src/app/programguide/components/DoughnutChart.vue